import React, { useState, useRef, useEffect } from 'react';
import style from './OTPInput.module.css';
import { Input } from '@mui/base';
const arr = Array.from({ length: 6 }, () => '');
const idPrefix = 'lincd-input-otp-';
export const OTPInput = ({ onClick }) => {
    const [number, setNumber] = useState(arr);
    const numberToString = number.join('');
    const numberIndex = useRef(number || []);
    numberIndex.current = number;
    useEffect(() => {
        if (numberToString.length === 6) {
            // isLoading(true);
            setTimeout(() => {
                onClick(numberToString);
            }, 500);
        }
    }, [numberToString, onClick]);
    return (React.createElement("div", { className: style.container },
        React.createElement("div", { className: style.innerContainer }, arr.map((num, index) => {
            return (React.createElement(Input, { value: numberIndex.current[index], onChange: (e) => {
                    var _a;
                    const inputValue = e.target.value;
                    if (/^\d$/.test(inputValue)) {
                        const newNumber = [...number];
                        newNumber[index] = inputValue;
                        setNumber(newNumber);
                        if (index < newNumber.length - 1) {
                            (_a = document.getElementById(`${idPrefix}${index + 1}`)) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                    }
                }, key: index, id: `${idPrefix}${index}`, type: 'number', 
                // if user delete the input, focus on previous input
                onKeyDown: (e) => {
                    var _a;
                    if (e.key === 'Backspace') {
                        const newNumber = [...number];
                        newNumber[index] = '';
                        setNumber(newNumber);
                        (_a = document.getElementById(`${idPrefix}${index - 1}`)) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                } }));
        }))));
};
//# sourceMappingURL=OTPInput.js.map